import { createSlice } from '@reduxjs/toolkit';

import { authApi } from './authApi';

interface successLoginResp {
  email: string;
  message: string;
  firstName: string;
  lastName: string;
  role: string;
  tenantId: string;
  token: string;
  teamId: string;
  id: string;
  tenant: object;
  ProfileURL: string;
  userExtId: string;
  userExtPassword: string;
  extNumber: string;
  permissions: {} | null;
}

interface AuthState {
  registerApiData: RegisterApiResponse | null;
  loginApiData: null | successLoginResp | { email: string; message: string };
  verifyEmailApiData: null | { email: string; message: string };
}

interface RegisterApiResponse {
  id: string;
  tenantId: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
  teamId: string | null;
}

const initialState: AuthState = {
  registerApiData: null,
  verifyEmailApiData: null,
  loginApiData: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRegisterApiData: (state, action) => {
      state.registerApiData = action.payload;
    },
    setLoginApiData: (state, action) => {
      state.loginApiData = action.payload;
    },
    setVerifyEmailApiData: (state, action) => {
      state.verifyEmailApiData = action.payload;
    },
    setAuthStateInitial: (state) => {
      state.registerApiData = null;
      state.loginApiData = null;
      state.verifyEmailApiData = null;
    },
  },
  extraReducers: (builder) => {
    // Register User
    builder.addMatcher(authApi.endpoints.registerUser.matchFulfilled, (state, action) => {
      const { id, tenantId, email, password, firstName, lastName, role, teamId } =
        action.payload.data;
      const registerData = { id, tenantId, email, password, firstName, lastName, role, teamId };
      state.registerApiData = registerData;
    });
    // Login User
    builder.addMatcher(authApi.endpoints.loginUser.matchFulfilled, (state, action) => {
      if (action.payload.success && action.payload.message === 'Login successful') {
        const user = action.payload.data.user;
        state.loginApiData = {
          firstName: user.firstName ?? '',
          lastName: user.lastName ?? '',
          role: user.role ?? '',
          email: user.email ?? '',
          tenantId: user.tenantId ?? '',
          token: user.token ?? '',
          message: user.message ?? '',
          teamId: user.teamId ?? '',
          id: user.id ?? '',
          tenant: user.tenant ?? '',
          ProfileURL: user.ProfileURL ?? '',
          userExtId: user.userExtId ?? '',
          userExtPassword: user.userExtPassword ?? '',
          extNumber: user.extNumber ?? '',
          permissions: user.permissions ?? null,
        };
      }
    });
    // auto login
    builder.addMatcher(authApi.endpoints.autoLoginUser.matchFulfilled, (state, action) => {
      if (action.payload.success && action.payload.message === 'Login successful') {
        const user = action.payload.data.user;
        state.loginApiData = {
          firstName: user.firstName ?? '',
          lastName: user.lastName ?? '',
          role: user.role ?? '',
          email: user.email ?? '',
          tenantId: user.tenantId ?? '',
          token: user.token ?? '',
          message: user.message ?? '',
          teamId: user.teamId ?? '',
          id: user.id ?? '',
          tenant: user.tenant ?? '',
          ProfileURL: user.ProfileURL ?? '',
          userExtId: user.userExtId ?? '',
          userExtPassword: user.userExtPassword ?? '',
          extNumber: user.extNumber ?? '',
          permissions: user.permissions ?? null,
        };
      }
    });
    builder.addMatcher(authApi.endpoints.loginUser.matchRejected, (state, action) => {
      const reqParams = action?.meta?.arg.originalArgs;
      const payload = action.payload as { data: { message: string } };
      state.loginApiData = { email: reqParams?.email, message: payload?.data?.message };
    });
    builder.addMatcher(authApi.endpoints.verifyEmail.matchFulfilled, (state, action) => {
      const reqParams = action?.meta?.arg.originalArgs;
      state.verifyEmailApiData = { email: reqParams?.email, message: 'Code Sent Successfully' };
    });
  },
});

export default authSlice.reducer;
export const { setRegisterApiData, setVerifyEmailApiData, setLoginApiData, setAuthStateInitial } =
  authSlice.actions;
